<template>
  <div class="info">
    <h1 class="info__title">Real Empowerment</h1>

    <dots-number activeDots='4'/>

    <div class="info text-center">
      <div class="info__header">
        <img class="info__img" src="/static/img/Real Empowerment.svg" alt="">
        <p class="info__header-text">
          The organisation carefully manages authority, decision making and autonomy to
          bring the best out of each member, fostering a spirit of entrepreneurship.
        </p>
      </div>
      <div class="info__footer">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import DotsNumber from '@/components/Evaluation/Dots';

export default {
  components: { DotsNumber },
  data() {
    return {
      id: 5,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Evaluation/Empowerment/Info.vue